import Immutable from 'immutable';
import { shallowEqual, useSelector } from 'react-redux';
import { getStoreFilters } from '../../selector';
import { IStore } from 'store/interface';
import { IFiltersRecord } from '../../interfaces';

export const useStoreFilters = () => ({
  filters: useSelector<IStore, Immutable.Record<IFiltersRecord>>(getStoreFilters, shallowEqual),
});
